/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M2 10.0859H22M4 5.08594H20C21.1046 5.08594 22 5.98137 22 7.08594V17.0859C22 18.1905 21.1046 19.0859 20 19.0859H4C2.89543 19.0859 2 18.1905 2 17.0859V7.08594C2 5.98137 2.89543 5.08594 4 5.08594Z"
      stroke="#262626"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
